var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40263_68797)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 49,
    height: 49,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6371 33L39.5746 38.7273L37.2734 36.124",
    stroke: "#39C38D",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0435 27.4364C38.9679 27.4364 36.9773 28.2553 35.5096 29.7129C34.0419 31.1706 33.2174 33.1476 33.2174 35.2091C33.2174 37.2705 34.0419 39.2476 35.5096 40.7052C36.9773 42.1629 38.9679 42.9818 41.0435 42.9818C43.1191 42.9818 45.1097 42.1629 46.5774 40.7052C48.045 39.2476 48.8696 37.2705 48.8696 35.2091C48.8696 33.1476 48.045 31.1706 46.5774 29.7129C45.1097 28.2553 43.1191 27.4364 41.0435 27.4364ZM41.0435 24.3273C43.9493 24.3273 46.7362 25.4737 48.7909 27.5145C50.8457 29.5552 52 32.3231 52 35.2091C52 38.0951 50.8457 40.863 48.7909 42.9037C46.7362 44.9444 43.9493 46.0909 41.0435 46.0909C36.6765 46.0909 32.9043 43.5415 31.1357 39.8727H16V35.2091C16 31.074 24.3426 28.9909 28.5217 28.9909C29.4609 28.9909 30.6191 29.0997 31.84 29.3018C32.8328 27.7743 34.1955 26.5186 35.8034 25.6495C37.4112 24.7804 39.2129 24.3258 41.0435 24.3273ZM30.087 35.2091C30.087 34.1209 30.2435 33.0638 30.5409 32.1C29.8835 31.9912 29.1948 31.9445 28.5217 31.9445C23.873 31.9445 18.9739 34.2142 18.9739 35.2091V36.9191H30.2278C30.1337 36.3539 30.0866 35.782 30.087 35.2091ZM28.5217 15C30.1822 15 31.7747 15.6551 32.9488 16.8213C34.123 17.9874 34.7826 19.569 34.7826 21.2182C34.7826 22.8673 34.123 24.449 32.9488 25.6151C31.7747 26.7812 30.1822 27.4364 28.5217 27.4364C26.8613 27.4364 25.2688 26.7812 24.0946 25.6151C22.9205 24.449 22.2609 22.8673 22.2609 21.2182C22.2609 19.569 22.9205 17.9874 24.0946 16.8213C25.2688 15.6551 26.8613 15 28.5217 15ZM28.5217 17.9536C27.65 17.9536 26.8139 18.2976 26.1975 18.9098C25.5811 19.522 25.2348 20.3524 25.2348 21.2182C25.2348 22.084 25.5811 22.9143 26.1975 23.5266C26.8139 24.1388 27.65 24.4827 28.5217 24.4827C29.3935 24.4827 30.2295 24.1388 30.846 23.5266C31.4624 22.9143 31.8087 22.084 31.8087 21.2182C31.8087 20.3524 31.4624 19.522 30.846 18.9098C30.2295 18.2976 29.3935 17.9536 28.5217 17.9536Z",
    fill: "#39C38D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40263_68797",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40263_68797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40263_68797",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/Received.1d54d2197aaf1b7f2714818f0b6f495f.svg";
export { ForwardRef as ReactComponent };